import { ANY, ARCHIVED, SELECT_ALL_FILTERS } from '../constants';
import { createStack } from 'hub-http';
import promiseClient from 'hub-http/adapters/promiseClient';
import { retry, safeMode } from 'hub-http/middlewares/core';
import Raven from 'raven-js';
// @ts-expect-error cookieAuth doesn't have declared types
import { allowMissingPortalId } from 'hub-http/middlewares/cookieAuth';
import hubapiStack from 'hub-http/stacks/hubapi';
import { getLocale } from '../utils/getLocale';
import { getPortalId } from '../utils/getPortalId';
export const DEFAULT_RETRY_DELAY_MS = 1000;
export const retryMiddleware = ({
  maxRetries
}) => retry(response => response.status === 0 || response.status >= 400 && response.status <= 599, Object.assign({
  delay: DEFAULT_RETRY_DELAY_MS
}, maxRetries && {
  maxRetries
}));
export const apiClientWithMiddleware = configOptions => {
  const middlewareStack = [safeMode, allowMissingPortalId, hubapiStack];
  if (configOptions && configOptions.maxRetries) {
    middlewareStack.push(retryMiddleware(configOptions));
  }
  return promiseClient(createStack(...middlewareStack));
};
export const getApiConfigs = () => {
  const portalId = getPortalId();
  const locale = getLocale() || 'en';
  const queryConfig = {
    query: {
      portalId
    }
  };
  const clientConfig = {
    maxRetries: 5
  };
  return {
    queryConfig,
    clientConfig,
    locale
  };
};
export const captureUndefinedPortalError = () => Raven.captureException(new Error('portalId not defined'));
export const getExtraQueryParamsForArchive = () => {
  const NOTIFICATION_SIDEBAR_USE_DELIVERY_KAFKA = 'NOTIFICATION_SIDEBAR_USE_DELIVERY_KAFKA';
  try {
    const useDeliveryKafka = localStorage.getItem(NOTIFICATION_SIDEBAR_USE_DELIVERY_KAFKA);
    return useDeliveryKafka ? {
      useDeliveryKafka
    } : {};
  } catch (e) {
    console.error(e);
    return {};
  }
};
export const filterTypesForApiCall = types => {
  return types.filter(type => type !== SELECT_ALL_FILTERS);
};
export const isNotificationTypes = filterOptions => {
  return filterOptions !== ARCHIVED && filterOptions !== SELECT_ALL_FILTERS && filterOptions !== ANY;
};